<template>
  <b-card
    class="mb-0"
  >
    <div class="mb-1">
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-1"
        >
          <h4 class="card-title mb-0 pt-50">
            Invocie Due Alerts</h4>
        </b-col>
        <b-col
          cols="12"
          md="8 ml-auto"
          class="col-xxl-6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-input-group class="d-none">
              <b-form-input
                v-model="searchQuery"
                placeholder="Search"
                @keyup.enter="updateSearchQuery"
              />
              <b-input-group-append>
                <b-button
                  variant="outline-primary"
                  @click="updateSearchQuery"
                >
                  <feather-icon
                    icon="SearchIcon"
                    size="14"
                  />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-button
              variant="outline-primary"
              class="ml-2"
              @click="back"
            >
              Back
            </b-button>
          </div>
        </b-col>
      </b-row>

    </div>

    <vue-good-table
      :columns="columns"
      :rows="invoiceAlerts.invoice_alerts"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Invoice -->
        <span v-if="props.column.field === 'invoice'">
          <b-link
            id="invoice_id"
            :to="{ name: 'invoice-view', params: { id: props.row.id } }"
          >
            <span>{{ props.row.invoice }}</span>
          </b-link>
        </span>

        <!-- Column: Currency -->
        <span v-if="props.column.field === 'cellRendererCurrency'">
          <span>{{ props.row.balance| currency('$ ', 2, { thousandsSeparator: ',' }) }}</span>
        </span>

        <!-- Column: Action -->
        <span
          v-if="props.column.field === 'action'"
          class="ml-0"
        >
          <span>
            <b-link
              v-show="props.row.timesheet_id !== null"
              id="view"
              :to="{ name: 'finance-and-accounting-timesheets-edit', params: { id: props.row.timesheet_id }}"
            >
              <b-badge
                pill
                variant="light-primary"
              ><feather-icon icon="EyeIcon" />
              </b-badge>
            </b-link>
            <b-link
              v-show="props.row.invoice_id !== null && $route.query.type === 'not_paid' && props.row.parent_type === 'Employer'"
              id="view"
              :to="{ name: 'finance-and-accounting-invoices-from-employers-edit', params: { id: props.row.invoice_id } }"
            >
              <b-badge
                pill
                variant="light-primary"
              ><feather-icon icon="EyeIcon" />
              </b-badge>
            </b-link>
            <b-link
              v-show="props.row.invoice_id !== null && $route.query.type === 'not_paid' && props.row.parent_type === 'Subvendor'"
              id="view"
              :to="{ name: 'finance-and-accounting-invoices-from-subvendors-edit', params: { id: props.row.invoice_id } }"
            >
              <b-badge
                pill
                variant="light-primary"
              ><feather-icon icon="EyeIcon" />
              </b-badge>
            </b-link>
            <b-link
              v-show="props.row.invoice_id !== null && $route.query.type === 'not_paid' && props.row.parent_type === 'Suppliers'"
              id="view"
              :to="{ name: 'finance-and-accounting-invoices-from-suppliers-edit', params: { id: props.row.invoice_id } }"
            >
              <b-badge
                pill
                variant="light-primary"
              ><feather-icon icon="EyeIcon" />
              </b-badge>
            </b-link>
            <b-link
              v-show="props.row.invoice_id !== null && $route.query.type === 'not_paid' && props.row.parent_type === 'Referrer'"
              id="view"
              :to="{ name: 'finance-and-accounting-invoices-from-referrers-edit', params: { id: props.row.invoice_id } }"
            >
              <b-badge
                pill
                variant="light-primary"
              ><feather-icon icon="EyeIcon" />
              </b-badge>
            </b-link>
            <b-link
              v-show="props.row.invoice_id !== null && $route.query.type === 'not_received'"
              id="view"
              :to="{ name: 'finance-and-accounting-invoices-to-vendors-edit', params: { id: props.row.invoice_id } }"
            >
              <b-badge
                pill
                variant="light-primary"
              ><feather-icon icon="EyeIcon" />
              </b-badge>
            </b-link>
            <b-button
              variant="outline-primary"
              class="btn-sm ml-75 px-50"
              @click="confirmIgnoreRecord(props.row)"
            >
              Ignore
            </b-button>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
      >
        <div class="d-flex justify-content-end flex-wrap">
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="invoiceAlerts.count"
              first-number
              last-number
              align="right"
              :per-page="1"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BLink,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import InvoiceAlerts from '@/js/invoicealerts'

export default {
  name: 'InvoiceDueAlerts',
  components: {
    BCard,
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BBadge,
    BLink,
    BPagination,
    VueGoodTable,
  },
  data() {
    return {
      searchQuery: '',
      pageLength: 10,
      dir: false,
      invoiceAlerts: {
        invoice_alerts: [],
        count: 1,
      },
      columns: [
        {
          label: '#',
          field: 'index',
          width: '70px',
          sortable: false,
        },
        {
          label: 'Vendor / Employer',
          field: 'name',
          sortable: false,
        },
        {
          label: 'Invoice #',
          field: 'invoice_number',
          sortable: false,
        },
        {
          label: 'Name',
          field: 'consultants',
          sortable: false,
        },
        {
          label: 'Period',
          field: 'period',
          width: '120px',
          sortable: false,
        },
        {
          label: 'Balance',
          field: 'cellRendererCurrency',
          width: '120px',
          sortable: false,
        },
        {
          label: 'Sent Date',
          field: 'sent_date',
          width: '120px',
          sortable: false,
        },
        {
          label: 'Due For',
          field: 'due_days',
          sortable: false,
        },
        {
          label: 'Actions',
          field: 'action',
          width: '120px',
          sortable: false,
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.$store.state.query.page
      },
      set(val) {
        this.$store.state.query.page = val
        InvoiceAlerts.getInvoiceAlerts(this, this.$route.query.type)
      },
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Active      : 'light-success',
        Inactive    : 'light-danger',
        Terminated  : 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.searchQuery = this.$store.state.query.query
    InvoiceAlerts.getInvoiceAlerts(this, this.$route.query.type)
  },
  methods: {
    confirmIgnoreRecord(obj) {
      this.$swal({
        title: 'Are you sure?',
        text: `you wan't to ignore this ${obj.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, ignore it!',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          InvoiceAlerts.ignoreAlert(this, obj.id)
        }
      })
    },
    alertIgnored(data) {
      InvoiceAlerts.getInvoiceAlerts(this, this.$route.query.type)
      this.$swal({
        icon: 'success',
        title: 'Alert Ignored!',
        text: data.return_message,
      })
    },
    alertNotIgnored(message) {
      this.$swal({
        icon: 'warning',
        title: 'Alert Not Ignored!',
        text: message,
      })
    },
    updateSearchQuery() {
      this.$store.state.query.query = this.searchQuery
      this.currentPage = 1
    },
    setInvoiceAlerts(invoiceAlerts) {
      this.invoiceAlerts = invoiceAlerts
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
